module.exports = __webpack_public_path__ + "img/heart_normal.12caa1e1.png";